// mtop限流
export const MTOP_DEBOUNCE_TIME = 1000;

// 列表默认条数
export const TABLE_DEF_PAGE_SIZE = 20;
export const TABLE_PAGE_SIZE_OPTS = ['20', '40', '60'];

// 成功后跳转等待时间
export const REDIRECT_DELAY_TIME = 1000;

// 实时请求接口白名单
export const REAL_MTOP_ARRAY = [
  'loan.interest.get',// 利息获取
  'register.bankInfo.list',// 银行，支行获取
  'register.agreements.get',// 入驻二维码，合同获取
  'register.agreement.signstatus',// 入驻是否已签约
  'loan.agreements.get',// 支用二维码，合同获取
  'loan.agreement.content.get',// 支用是否已签约
  'loan.loanplaninfo.get', // 获取贷款信息
];

// 客服信息
export const CUSTOMER_SERVICE = {
  phone: '010-56972846',
  email: 'yuxiaobao@service.alibaba.com'
};

export const INVOICE_POST_ADDR = '北京市朝阳区望京东园阿里中心-望京B座 B1层小邮局 苡然 010-56972846';

// 字符串定义换行符
export const ENTER_CHARA = '@n_@';

// 不显示loading效果白名单
export const NO_LOADING_MODELS = [
  'collections/getInterest',// 利息获取
  'accountReceive/getBankList',// 银行获取
  'accountReceive/getBankBranchList',// 支行获取
  'contract/getAgreements',// 入驻二维码，合同获取 // 支用二维码，合同获取
  'contract/getSignStatus',// 入驻是否已签约 // 支用是否已签约
];

export const VALIDITY_TYPE = ['SHORT_TERM', 'LONG_TERM'];

// 速回宝文案
export const PRODUCT_NAME = '速回宝';



// WEBPACK FOOTER //
// ./src/constants/config.js